import {createRouter, createWebHashHistory} from 'vue-router'
import Home from '../Pages/Home.vue'
import Achat from '../Pages/Achat.vue'
import Paiement from '../Pages/Paiement.vue'
import Aide from '../Pages/Aide.vue'
import Error404 from '../Pages/Error404.vue'
import SuccesAchat from '../Pages/SuccesAchat.vue'
import SuccesRechargement from '../Pages/SuccesRechargement.vue'
import Rechargement from '../Pages/Rechargement.vue'
import Erreur from '../Pages/Erreur.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: { title: 'Accueil — Billetterie Réseau Colibri' }
  },
  {
    path: '/aide',
    name: 'aide',
    component: Aide,
    meta: { title: 'Mode d\'emploi — Billetterie Réseau Colibri' }
  },
  {
    path: '/achat/:codeProduit',
    name: 'achat',
    component: Achat,
    meta: { title: 'Achat — Billetterie Réseau Colibri' }
  },
  {
    path: '/rechargement/:rechargementId?',
    name: 'rechargement',
    component: Rechargement,
    meta: { title: 'Rechargement — Billetterie Réseau Colibri' }
  },
  {
    path: '/paiement/:paylineToken',
    name: 'paiement',
    component: Paiement,
    meta: { title: 'Paiement en cours — Billetterie Réseau Colibri' }
  },
  {
    path: '/succes-achat',
    name: 'succesAchat',
    component: SuccesAchat,
    meta: { title: 'Achat confirmé — Billetterie Réseau Colibri' }
  },
  {
    path: '/succes-rechargement',
    name: 'succesRechargement',
    component: SuccesRechargement,
    meta: { title: 'Rechargement confirmé — Billetterie Réseau Colibri' }
  },
  {
    path: '/erreur',
    name: 'erreur',
    component: Erreur,
    meta: { title: 'Erreur — Billetterie Réseau Colibri' }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'error',
    component: Error404,
    meta: { title: 'Page introuvable — Billetterie Réseau Colibri' }
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes: routes
})

router.afterEach((to, from) => {
  window._paq.push(['setCustomUrl', 'www.reseau-colibri.fr/billetterie/#/' + to.fullPath])
  window._paq.push(['trackPageView'])
})

export default router
